import {
  Button,
  Grid,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import _ from 'lodash'
import React from 'react'

import { hasAccess } from '../../../utils/api'
import { getCustomerTypeDisplayName } from '../../../utils/common'
import EditActionComponent from '../../common/EditActionComponent'
import { ComplexTaxDataContext } from '../TaxOption'
import TaxChangesConfirmationModal from '../TaxChangesConfirmationModal'
import { buildComplexTaxChanges } from '../taxChangeUtils'
import ComplexTerritoryTaxItem from './ComplexTerritoryTaxItem'

const taxItemsKeyList = ['cityTax', 'countyTax', 'stateTax', 'federalTax']

export default class ComplexTaxOptionItem extends React.PureComponent {
  state = {
    showChangeConfirmation: false,
    pendingChanges: [],
  }

  editSnapshot = null

  onChange = (key) => (propToUpdate, value) => {
    const { data = {} } = this.props

    var newTax = {}
    if (propToUpdate === 'taxOrder' && value === 'PreTaxed') {
      newTax = {
        ...data[key],
        [propToUpdate]: value,
        activeDeliveryFeeTax: false,
      }
    } else {
      newTax = {
        ...data[key],
        [propToUpdate]: value,
      }
    }

    this.props.onChange(key, newTax)
  }

  saveChanges = () => {
    this.props.onSave((response) => {
      this.editSnapshot = null
      this.props.clearEditingIndex()
      this.props.disableEdit()
      this.props.handleAnyEdit(false)
    })
  }

  onSave = () => {
    const changes = buildComplexTaxChanges(this.editSnapshot || {}, this.props.data || {})
    if (!changes.length) {
      this.saveChanges()
      return
    }
    this.setState({
      showChangeConfirmation: true,
      pendingChanges: changes,
    })
  }

  onEnable = () => {
    const { data } = this.props

    this.props.onChange('active', !data.active, this.onSave)
  }

  renderEnableButton = (active) => {
    return (
      <Button className={`${active ? 'danger' : 'primary'}-button margin`} onClick={this.onEnable}>
        {active ? 'Disable' : 'Enable'}
      </Button>
    )
  }

  onCancel = () => {
    this.editSnapshot = null
    if (this.props.clearEditingIndex) this.props.clearEditingIndex()
    if (this.props.onCancel) this.props.onCancel()
    this.props.handleAnyEdit(false)
  }

  onEdit = () => {
    this.editSnapshot = _.cloneDeep(this.props.data || {})
    if (this.props.setEditingIndex) this.props.setEditingIndex()
    if (this.props.enableEdit) this.props.enableEdit()
    this.props.handleAnyEdit(true)
  }

  closeChangeConfirmation = () => {
    this.setState({
      showChangeConfirmation: false,
      pendingChanges: [],
    })
  }

  confirmChangeAndSave = () => {
    this.setState({ showChangeConfirmation: false }, this.saveChanges)
  }

  render() {
    const {
      data = {},
      editMode,
      showExcise = true,
      showEdit = true,
      isNonCannabis = false,
      allowDelivery,
      nalExciseAfterCityTax,
      isNalTaxesOnly,
      surchargeTerritoryTaxFlag,
      isCDTFAEnabled = false,
      consumerTypes,
      taxOnSubtotalFlag = false,
      isEditing,
    } = this.props
    const { showChangeConfirmation, pendingChanges } = this.state
    const showDeliveryFee = allowDelivery
    const customerTypeDisplayName = getCustomerTypeDisplayName(consumerTypes, data.consumerType)
    const complexTaxScope = customerTypeDisplayName
      ? `${customerTypeDisplayName} Tax`
      : 'Complex Tax'
    const complexTaxTitle = `${
      isNonCannabis ? 'Non-cannabis' : 'Cannabis'
    } - ${complexTaxScope} - Confirm Changes`
    return (
      <Grid container>
        <TaxChangesConfirmationModal
          open={showChangeConfirmation}
          title={complexTaxTitle}
          changes={pendingChanges}
          groupByTerritory={true}
          onClose={this.closeChangeConfirmation}
          onConfirm={this.confirmChangeAndSave}
        />
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ListItem>
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <h1 className="table-heading">{customerTypeDisplayName}</h1>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div
                  className="full-width"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  {hasAccess() && showEdit && (!this.props.isAnyEditing || isEditing) ? (
                    <EditActionComponent
                      editMode={isEditing}
                      onSave={this.onSave}
                      onEdit={this.onEdit}
                      onCancel={this.onCancel}
                    />
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6} className="customer_type">
                Customer Type
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {customerTypeDisplayName}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <div className="table-scroll complex-tax-table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Display Name</TableCell>
                    <TableCell>Tax Rate</TableCell>
                    <TableCell>Compound</TableCell>
                    <TableCell>Tax Order</TableCell>
                    <TableCell>Active</TableCell>
                    {taxOnSubtotalFlag ? <TableCell>Tax on Subtotal</TableCell> : null}
                    {!isNonCannabis && (showExcise ? <TableCell>Tax Excise</TableCell> : null)}
                    {showDeliveryFee ? <TableCell>Tax Delivery Fee</TableCell> : null}
                    {surchargeTerritoryTaxFlag ? <TableCell>Tax Payment Fee</TableCell> : null}
                    {isCDTFAEnabled ? <TableCell>CDTFA Tax</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {taxItemsKeyList.map((taxKey, index) => {
                    const tax = data[taxKey] || {}

                    return (
                      <ComplexTaxDataContext.Consumer>
                        {(taxOptionSettings) => (
                          <ComplexTerritoryTaxItem
                            key={index}
                            tax={tax}
                            editMode={isEditing}
                            onChange={this.onChange(taxKey)}
                            showExcise={showExcise}
                            showDeliveryFee={showDeliveryFee}
                            isNonCannabis={isNonCannabis}
                            isNalTaxesOnly={isNalTaxesOnly}
                            nalExciseAfterCityTax={nalExciseAfterCityTax}
                            enableDeliveryFeeBeforeExciseTax={
                              (taxOptionSettings &&
                                taxOptionSettings.exciseTax &&
                                taxOptionSettings.exciseTax.enableDeliveryFeeBeforeExciseTax) ||
                              false
                            }
                            enableSurchargeFeeBeforeExciseTax={
                              (taxOptionSettings &&
                                taxOptionSettings.exciseTax &&
                                taxOptionSettings.exciseTax.enableSurchargeFeeBeforeExciseTax) ||
                              false
                            }
                            onCancel={this.props.onCancel}
                            surchargeTerritoryTaxFlag={surchargeTerritoryTaxFlag}
                            isCDTFAEnabled={isCDTFAEnabled}
                            taxOnSubtotalFlag={taxOnSubtotalFlag}
                          />
                        )}
                      </ComplexTaxDataContext.Consumer>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          </ListItem>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/ComplexTaxOptions/ComplexTaxOptionItem.js